// extracted by mini-css-extract-plugin
export var resourceTileList = "W_c2";
export var resourceTileListContainer = "W_c3";